import { IApplicationState } from '../../../types/redux';

export function documentSelector(state: IApplicationState) {
  return state.document;
}

export function linksSelector(state: IApplicationState) {
  return state.links;
}
